import React from "react";
import { NavWrap } from "../ShopForTyres";
import Table from "../../common/Table";
import { Switch } from "antd";
import moment from "moment";

const UserAndRoles = () => {
  const columns = [
    {
      header: "",
      accessor: "userImg",
      width: 7,
      cell: () => {
        return (
          <div className="flex-center">
            <img
              src={
                "https://www.pngitem.com/pimgs/m/256-2560255_user-icon-user-white-icon-transparent-hd-png.png"
              }
              width={40}
              height={40}
              className="br50 ml1"
              alt="roles"
            />
          </div>
        );
      },
    },
    {
      header: "User name",
      accessor: "userName",
      width: 23,
    },
    {
      header: "Role",
      accessor: "role",
      width: 20,
    },
    {
      header: "Created On",
      accessor: "createdDate",
      width: 20,
    },
    {
      header: "Status",
      accessor: "status",
      width: 15,
    },
    {
      header: "Actions",
      accessor: "isActive",
      width: 15,
      cell: () => {
        return <Switch />;
      },
    },
  ];
  const data = [
    {
      isActive: false,
      status: "Active",
      createdDate: moment(new Date()).format("DD MMM'YY HH:mm"),
      role: "Customer main access",
      email: "john@stmp.com",
      userName: "John",
      userImg: "",
    },
  ];
  return (
    <NavWrap>
      <div className="userRoles">
        <Table columns={columns} data={data} />
      </div>
    </NavWrap>
  );
};

export default UserAndRoles;
